import { render, staticRenderFns } from "./title-bubble.vue?vue&type=template&id=de84ad70&scoped=true&"
import script from "./title-bubble.vue?vue&type=script&lang=js&"
export * from "./title-bubble.vue?vue&type=script&lang=js&"
import style0 from "./title-bubble.vue?vue&type=style&index=0&id=de84ad70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de84ad70",
  null
  
)

export default component.exports